export default __webpack_public_path__ + "static/media/Catering_Mobile.8f2db1ab.svg";